//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import SaveConfigurationButton from "src/components/loader/buttons/SaveConfigurationButton";

const ExtractButton = (props) => {
  return (
    <SaveConfigurationButton
      label="Extract"
      url="loader/extract"
      icon={<GetAppIcon />}
      {...props}
    />
  );
};
export default ExtractButton;
